Namespace.create("cv.Views.Team.Setup").PageView = Marionette.LayoutView.extend({
  className: "view-team-setup-page",

  template: cv.Templates["team/setup/page/view"],

  behaviors: [
    {
      behaviorClass: cv.FormBehavior,
    },
  ],

  regions: {
    custom_fields: "#custom-fields",
  },

  events: {
    "keyup #name": "updateName",
    "keyup #stub": "updateStub",
  },

  validation: {
    photo_path: [],
    name: [
      {
        required: "true",
        msg: "Required",
      },
    ],
    stub: [
      {
        required: "true",
        msg: "Invalid URL",
      },
      {
        valid_team_stub: true,
      },
    ],
    description: [],
    funds_needed: [
      {
        min: 0,
        msg: "Invalid amount",
      },
    ],
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    // Save profile will fire before this second one is fired
    this.listenTo(
      this,
      "form:saved",
      function () {
        cv.project.set("team.id", this.model.get("id"));
        cv.project.set("team.url", this.model.get("url"));

        cv.router.navigate("/team_setup/appeal", { trigger: true });
      },
      this
    );

    // Set this for the validation
    this.model.set("campaign.id", cv.campaign.get("id"));

    console.log("PageView initialized");
  },

  templateHelpers: function () {
    return {
      url: cv.campaign.get("url"),
      team_photo_upload: cv.Templates["global/form/form_upload_profile"]({
        label: "Team Photo",
        id: "photo_path",
        photo_default: cv.campaign.get("default_team_photo"),
      }),
      enable_team_funds_needed: cv.campaign.get("enable_team_funds_needed") == 1 ? true : false,
      currency_code: cv.campaign.get("currency_code"),
      team_recommended_amount:
        cv.campaign.get("team_recommended_amount") > 0
          ? cv.campaign.get("team_recommended_amount")
          : false,
    };
  },

  updateName: function () {
    // If our stub is blank and we are entering this the first time
    if (this.$("#stub").val() == "" || this._model_clone.get("name") == "") {
      this.$("#stub")
        .val(cv.convertToSlug(this.$("#name").val()))
        .trigger("change");
      this.updateStub();
    }
  },

  updateStub: function () {
    this.$(".url-preview").text(this.$("#stub").val());
  },

  onAttach: function () {
    // Change document title
    document.title = "Team Setup | General Information";

    var customFieldsView = new cv.CustomFieldsFormView({
      values: this.model.get("custom_values"),
      type: "team",
      container: this.$("#additional-info"),
    });

    // Bind a listener
    this.listenTo(
      customFieldsView,
      "form:saved",
      function (view) {
        this.trigger("form:set", "custom_values", view.getValues());
      },
      this
    );

    // Link the custom form
    this.trigger("form:link", customFieldsView);
    this.showChildView("custom_fields", customFieldsView);

    if (cv.campaign.get("team_recommended_amount") > 0) {
      setTimeout(() => {
        this._model_clone.set("funds_needed", cv.campaign.get("team_recommended_amount"));
      }, 25);
    }
  },

  onDestroy: function () {},
});
